var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-print": _vm.readOnlyView || !_vm.isNewEntity,
          "show-delete": false,
          "show-save": _vm.isSave && !_vm.readOnlyView && _vm.isNewEntity,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.entity
              ? _c("payment-entry-side-menu", {
                  ref: "sideMenu",
                  attrs: { "vendor-name": `${_vm.entity.vendorName}` },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm.entity
              ? _c("router-view", {
                  key: _vm.$route.fullPath,
                  ref: "currentChild",
                  attrs: {
                    "is-tiled": false,
                    "route-name": _vm.$route.name,
                    "gst-paid": _vm.gstPaid,
                    "read-only-view": _vm.readOnlyView,
                    "is-new-entity": _vm.isNewEntity,
                    "can-print-remit-advice": _vm.canPrintRemitAdvice,
                  },
                  on: {
                    printRemitAdvice: function ($event) {
                      return _vm.printRemitAdvice()
                    },
                  },
                  model: {
                    value: _vm.entity,
                    callback: function ($$v) {
                      _vm.entity = $$v
                    },
                    expression: "entity",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "unsaved-modal",
        {
          attrs: { active: _vm.isUnsavedModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isUnsavedModalActive = $event
            },
            close: function ($event) {
              return _vm.closeUnsavedModal()
            },
            skipSave: function ($event) {
              return _vm.skipSave()
            },
            saveContinue: function ($event) {
              return _vm.saveContinue()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Unsaved Changes"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v("There are unsaved changes. Please select action below"),
          ]),
        ]
      ),
      _c(
        "save-conflict-modal",
        {
          attrs: { active: _vm.isSaveConflictModalActive },
          on: {
            "update:active": function ($event) {
              _vm.isSaveConflictModalActive = $event
            },
            close: function ($event) {
              return _vm.closeAllModal()
            },
            reload: function ($event) {
              return _vm.reloadData()
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Change conflict"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _vm._v(
              "The data on the server is newer than the local copy. Please reload local data."
            ),
          ]),
        ]
      ),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmSavePrintModalActive,
                "ok-text": "Save & Print",
                "cancel-text": "Print",
                "close-text": "Close",
                "show-close": true,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmSavePrintModalActive = $event
                },
                ok: function ($event) {
                  return _vm.save()
                },
                cancel: function ($event) {
                  return _vm.print()
                },
                close: function ($event) {
                  return _vm.closeSavePrintModal()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Save and Print"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " Do you want to Save and Print the Remittance Advice? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.entity
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isTaxWhModalActive,
                "ok-text": "Ok",
                "cancel-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isTaxWhModalActive = $event
                },
                ok: function ($event) {
                  return _vm.ok()
                },
                cancel: function ($event) {
                  return _vm.closeTaxWhModal()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("With-Hold Tax"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " You have indicated that With Hold Tax applies to these Payments. Ok to Continue? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }